export default __webpack_public_path__ + "static/media/referral_status_3.28b00a67.svg";